import styled from "styled-components";
import { IconButton, WrapperContainer } from "../../../../../components";

export const ChangeHistorySectionStyled = styled(WrapperContainer)`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const OpenModalButton = styled(IconButton)`
  position: absolute;
  top: 16px;
  right: 16px;
`;
